import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import dashboardStyle from "assets/jss/layouts/dashboard/dashboardStyle";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { RouteDashboard, RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";
import Header from "../Components/Header";
import Sidebar from "./Sidebar";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    component: any;
    path: string;
}

interface IState {
    acceptedCookies: boolean;
}

type Props = IAppProps & RouteComponentProps & WithStyles<typeof dashboardStyle> & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////////////////////

class Dashboard extends React.PureComponent<Props, IState> {
    private mainPanel: HTMLElement;

    constructor(props: Props) {
        super(props);
        if (props.i18n.language != Session.uiCulture) props.i18n.changeLanguage(Session.uiCulture);
        this.state = { acceptedCookies: Session.user.acceptedCookies };
    }

    //
    public componentDidUpdate(e: Props) {
        if (e.history.location.pathname !== e.location.pathname) {
            this.mainPanel.scrollTop = 0;
        }
    }

    //
    public render() {
        const { classes, path, ...rest } = this.props;

        return (

            <div className={classes.root}>
                <Header
                    fullView
                    {...rest}
                />

                <Sidebar
                    observerRightComponentId="infobox"
                    path={window.location.pathname}
                />

                <main className="content" ref={(ref) => { this.mainPanel = ref; }}>
                    <Switch>
                        {
                            RouteDashboard.map((v, index) => {
                                const { component: Component, componentProps, ...rest } = v;
                                return (
                                    <Route
                                        {...rest}
                                        key={index}
                                        render={props => (<Component {...props} {...componentProps} />)}
                                    />);
                            })
                        }
                        <Redirect from="*" to={RoutePaths.TimelineStartup} exact />
                    </Switch>
                </main>


                {
                    this.state.acceptedCookies !== true &&
                    <div className="cookieConsent">
                        <div className="cookieContent">
                            {this.props.t("Message.AcceptCookie")}
                        </div>
                        <div>
                            <button className="cookieButton"
                                onClick={
                                    () => {
                                        if (api.acceptCookies()) {
                                            Session.updateAcceptCookie();
                                            this.setState({ acceptedCookies: true });
                                        }
                                    }
                                }
                            >
                                <span>{this.props.t("Common.Buttons.IUnderstoodText")}</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default withTranslation()(withStyles(dashboardStyle)(Dashboard));